import { z } from "zod";

export enum EElectricityTarif {
  OFF_PEAK_HOUR = "offPeakHours",
  PEAK_HOUR = "peakHours",
}

const electricityPricesSchema = z.object({
  [EElectricityTarif.OFF_PEAK_HOUR]: z.number().nullable(),
  [EElectricityTarif.PEAK_HOUR]: z.number().nullable(),
});

export const siteConsumptionInfosSchema = z.object({
  siteArea: z.number().nullable(),
  electricityPrices: electricityPricesSchema,
});

export const editSiteConsumptionInfosSchema = z.object({
  area: z.number().nullish(),
  peakHoursPrice: z.number().nullish(),
  offPeakHoursPrice: z.number().nullish(),
});

export type TSiteConsumptionInfos = z.infer<typeof siteConsumptionInfosSchema>;
export type TEditSiteConsumptionInfosBody = z.infer<typeof editSiteConsumptionInfosSchema>;
